module.exports = __webpack_public_path__ + "img/androidFirstSetting.04fd7ed3.webp";